module.exports = __webpack_public_path__ + "img/gallery.74ca3805.svg";